// private routes.tsx
import { Box } from "@mui/material";
import { Outlet, Route, useLocation } from "react-router-dom";
import {
  AdminPage,
  AnalyticsPage,
  BusinessDetailsPage,
  CheckInsAnalyticsPage,
  CheckOutsAnalyticsPage,
  ExperiencesPage,
  FollowersAnalyticsPage,
  GlobalAnalyticsPage,
  HomePage,
  MenuPage,
  ProductAnalyticsPage,
  ProductsPage,
  SettingsPage,
} from "../pages";

export const PrivateLayout = () => {
  const location = useLocation();
  const bgColor = location.pathname === "/admin" ? "#242424" : "";

  return (
    <Box sx={{ backgroundColor: bgColor, height: "100vh", pt: 2 }}>
      <Outlet />
    </Box>
  );
};

export const PrivateRoutes = [
  <Route key="private-routes" element={<PrivateLayout />}>
    <Route path="/" element={<HomePage />} />
    <Route path="/analytics" element={<AnalyticsPage />} />
    <Route path="/analytics/followers" element={<FollowersAnalyticsPage />} />
    <Route path="/analytics/checkins" element={<CheckInsAnalyticsPage />} />
    <Route path="/analytics/products" element={<ProductAnalyticsPage />} />
    <Route path="/analytics/checkouts" element={<CheckOutsAnalyticsPage />} />
    <Route path="/analytics/global" element={<GlobalAnalyticsPage />} />
    <Route path="/menu" element={<MenuPage />} />
    <Route path="/products" element={<ProductsPage />} />
    <Route path="/business-details" element={<BusinessDetailsPage />} />
    <Route path="/admin" element={<AdminPage color={null} />} />
    <Route path="/settings" element={<SettingsPage />} />
    <Route path="/experiences" element={<ExperiencesPage />} />
  </Route>,
];
